import { useTranslation } from 'react-i18next';

import { IngredientTabProps } from 'components/desktop/Ingredient/IngredientComponent';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import NutritionDiagram from 'components/desktop/_general/NutritionDiagram/NutritionDiagram';
import * as NutrientList from 'types/Ingredient/Detail/NutrientList';

export const IngredientNutritionDiagramCard = ({
	state,
	data,
}: IngredientTabProps): JSX.Element => {
	const { t } = useTranslation();

	const getMacroNutrientChartData = (): { label: string; value: number }[] => {
		const nutrients = NutrientList.merge(state.nutrients, state.baseIngredientNutrients);

		if (data.nutrients) {
			const macroWeight = data.nutrients
				.filter((n) => n.isMacroNutrient)
				.reduce((p, c) => p + (nutrients.find((x) => x.id == c.id)?.value ?? 0), 0);

			const macros = data.nutrients
				.filter((n) => n.isMacroNutrient)
				.map((n) => {
					return {
						label: n.name,
						value: (nutrients.find((x) => x.id == n.id)?.value ?? 0) / macroWeight,
					};
				});

			return macros;
		}
		return [];
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="ingredient-nutriscore-diagram-card"
			title={t('_general:NUTRI_DIAGRAM')}
			content={<NutritionDiagram data={getMacroNutrientChartData()}></NutritionDiagram>}
		></FoldableCard>
	);
};
